<div class="container-fluid">
        <div class="row" style="background-color: white; margin-top: 2px; margin-bottom: 13px; padding-top: 50px;">
            <div class="col-12 col-sm-12 col-md-6 d-block d-sm-block d-md-none">
                <div class="row">
                    <div class="col-12">
                        <div class="rounded-pill text-muted backgroundHighligthHeader">
                            <span class="primary-color"> {{ 'HOME.LABEL1' | translate }}</span>
                            <span class="muted-color"> {{ 'HOME.LABEL2' | translate }}</span>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div id="banner" style="background-size:100% auto;width:100%;">
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-10 col-sm-10 col-md-4" style="margin-left:5%;">
                <div class="d-block d-sm-block d-md-none text-center">
                    <h1 class="primary-color">{{ 'HOME.LABEL3' | translate }}</h1>
                </div>

                <div class="my-3">
                    <span class="titleName muted-color-2">{{ 'HOME.LABEL4' | translate }} </span> <span class="titleNameBold muted-color-2">{{this.storageService.getData('userName')}}</span>
                </div>
                <div class="my-3">
                    <span class="regularText muted-color">{{ 'HOME.LABEL5' | translate }}</span>
                </div>

                <div id="icon" class="text-center d-block d-sm-block d-md-flex mb-5">
                    <img/>
                </div>

                <div class="checklist">
                    <div>
                        <fa-icon [icon]="faCheck" class="fa-solid primary-color " style="font-size: 17px;margin-right: 5%;"></fa-icon>
                        <span class="regularText muted-color">{{ 'HOME.LABEL6' | translate }}</span>
                    </div>
                    <div>
                        <fa-icon [icon]="faCheck" class="fa-solid primary-color " style="font-size: 17px;margin-right: 5%;"></fa-icon>
                        <span class="regularText muted-color">{{ 'HOME.LABEL7' | translate }} </span>
                    </div>
                    <div>
                        <fa-icon [icon]="faCheck" class="fa-solid primary-color " style="font-size: 17px;margin-right: 5%;"></fa-icon>
                        <span class="regularText muted-color">{{ 'HOME.LABEL8' | translate }}</span>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-12 col-md-7 d-none d-sm-none d-md-block" >
                <div class="row">
                    <div class="col-12 d-flex justify-content-end">
                        <div class="rounded-pill text-muted backgroundHighligthHeader" style="margin-right:3%">
                            <span class="primary-color" id="HOME.LABEL2">{{ 'HOME.LABEL9' | translate }}</span>
                            <span class="muted-color"> {{ 'HOME.LABEL10' | translate }}</span>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 d-flex justify-content-end" >
                        <div id="banner" style="margin-right:3%;">
                    
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-4" style="background-color: white;">
            <div class="col marginProduct" >
                <div class="marginTitleProducts">
                    <span class="muted-color titleFont">{{ 'HOME.LABEL11' | translate }}</span><br>
                    <span class="muted-color">{{ 'HOME.LABEL12' | translate }}</span>
                </div>

                    <app-device></app-device>
            </div>
        </div>
        <!-- <div class="row my-3" >
            <div class="col-12 text-center">
                <span class="contactText">Te recordamos que tus art&iacute;culos est&aacute;n protegidos desde el 1er d&iacute;a de compra con las coberturas por Variaci&oacute;n de Voltaje y Descarga El&eacute;ctrica.</span>
            </div>
        </div> -->
        <!-- <app-whatsapp></app-whatsapp> -->
        <app-footer></app-footer>

</div>